import Table from "/src/components/table";
import botService from "../../services/botService";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import capitalizeFirstLetter from "../../../../utils/capitalizeFirstLetter";
import { formatDate } from "/src/utils/formatDate";
import { useNavigate } from "react-router-dom";
import ModalManager from "@ebay/nice-modal-react";
import { useToastDispatchContext } from "/src/layouts/toast/context/toastContext";
import getCutToken from "/src/utils/getCutToken";
import urlWithRoutingCompany from "/src/utils/urlWithRoutingCompany";
import { env } from "/src/var/env";
import storage from "/src/utils/storage";
import hasPermission from "/src/utils/hasPermission";

function BotTable() {
    const navigate = useNavigate();
    const toast = useToastDispatchContext();

    const { getBots, deleteBot } = botService;
    const company = storage("session").get("company");
    const cells = [
        {
            column: "Name",
            name: "name",
            sort: true,
            show: (value) => <span style={{ fontWeight: 700, color: hasPermission("update_bot") ? "var(--main)" : "", cursor: hasPermission("update_bot") ? "pointer" : "" }} onClick={() => { hasPermission("update_bot") ? onClickRedirect({ row: { name: value } }) : null }} >{value}</span>,
        },
        {
            column: "Language",
            name: "language.slug",
            show: (value) => <span className={"flag-icon flag-icon-" + value.toLowerCase()} />,
        },
        {
            column: "Token",
            name: "secret_token",
            show: (value) => (
                <span
                    style={{ color: "var(--main)", cursor: "pointer" }}
                    onClick={(e) =>
                        navigator.clipboard.writeText(value).then((_) => {
                            toast.success("Copy token to clipboard", "You can paste this token where you need !", 5000);
                        })
                    }>
                    {" "}
                    {getCutToken(value)}
                </span>
            ),
        },
        {
            column: "Api's URL",
            name: "id",
            show: (value) => (
                <span
                    style={{ color: "var(--main)", cursor: "pointer" }}
                    onClick={(e) =>
                        navigator.clipboard
                            .writeText(
                                env.REACT_APP_API_PATH.split("/api/v1")[0] +
                                "/" +
                                company.name +
                                "/bots/" +
                                value +
                                "/api/telephony"
                            )
                            .then((_) => {
                                toast.success(
                                    "Copy token to clipboard",
                                    "You can paste this token where you need !",
                                    5000
                                );
                            })
                    }>
                    {" "}
                    {getCutToken(
                        env.REACT_APP_API_PATH.split("/api/v1")[0] +
                        "/" +
                        company.name +
                        "/bots/" +
                        value +
                        "/api/telephony"
                    )}{" "}
                    {/*getCutToken("nub")*/}
                </span>
            ),
        },
        {
            column: "Description",
            name: "description",
            show: (value) => capitalizeFirstLetter(value),
        },
        {
            column: "Last Opening",
            name: "updated_at",
            sort: true,
            show: (value) => formatDate(value),
        },
        {
            column: "Save Conversation",
            name: "conversation_storage_time",
            show: (value) =>
                value > 0 ? (
                    <i className="fa fa-check" aria-hidden="true" style={{ color: "var(--main)" }} />
                ) : (
                    <span style={{ color: "var(--main)", fontWeight: "bolder" }}>X</span>
                ),
        },
    ];

    const onClickUpdate = ({ row }) =>
        navigate(urlWithRoutingCompany("/bot/update"), { state: { data: row, type: "update" } });

    const onClickRedirect = ({ row }) => navigate(urlWithRoutingCompany("/bots/" + row.name));
    //const onClickAdd = ({row, addRow}) => ModalManager.show(LogoutModal).then((bot) => addRow(bot));
    const onClickAdd = ({ deleteRow, row }) => navigate(urlWithRoutingCompany("/bot/create"));

    const onClickDelete = ({ row, deleteRow }) => {
        const { id, name } = row;
        ModalManager.show(ApiModal, {
            title: "Delete bot " + name,
            body: "Do you really want to delete bot " + name,
            api: {
                request: deleteBot,
                param: [id],
            },
            buttons: [
                { className: "validate", label: "Cancel" },
                { className: "cancel", label: "Delete", type: "submit" },
            ],
            confirm: {
                name: name,
                fieldName: "the bot",
            },
            maxTitleSize: 40,
        }).then(
            (res) => {
                if (res != null && res.data?.includes("dashboard_variables")) {//error
                    toast.error("Error", "Please, remove the dashboard of the bot first.", 5000);
                }
                else {
                    deleteRow(id);
                }
            }

        )
    };

    const actions = [
        hasPermission("update_bot")
            ? { className: "fas fa-cog action-button edit_action", style: {}, onClick: onClickUpdate }
            : null,
        hasPermission("update_bot")
            ? { className: "fas fa-edit action-button profil_action", style: {}, onClick: onClickRedirect }
            : null, // the padding for this icon is weird...
        hasPermission("delete_bot")
            ? { className: "fas fa-trash action-button delete_action", style: {}, onClick: onClickDelete }
            : null,
    ].filter((action) => action);

    const buttons = [hasPermission("create_bot") ? { icon: "fas fa-plus", onClick: onClickAdd } : null].filter(
        (button) => button
    );

    const filters = [{ type: "input", placeholder: "content", name: "term" }];

    return <Table name="bot" cells={cells} api={getBots} actions={actions} buttons={buttons} filters={filters}></Table>;
}

export default BotTable;
